import { Box } from "@mui/material";
import {
  CustomAutocomplete,
  CustomDropdown,
  CustomFileInput,
  CustomNumberInput,
  CustomTextarea,
  CustomTextInput,
} from "components/atoms";
import ButtonCheckbox from "components/atoms/CheckboxButton";
import CustomeFilePreview from "components/atoms/CustomeFilePreview";
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { getValueAtPath, setValueAtPath } from "./utils/utils";

const CustomDynamic = (props) => {
  const {
    element: orgElement,
    elementIndex,
    currentData,
    data,
    elements,
    sx = {},
    cellRef,
    parantRender,
    specificRender,
    path = [],
    handleSpecificDynamicType = false,
    errorRef = false,
        metadata = {}
    } = props

    const { mainRowIndex, isHaveMultiple = false, currentMultipleStageIndex = false, trackChanges } = metadata

    let element = orgElement

    const errors =
        !isHaveMultiple
    ? errorRef?.error?.[mainRowIndex]?.[path.join(".")]?.[element?.uniqueName]
            : errorRef?.error?.[mainRowIndex]?.[path.join(".")]?.[currentMultipleStageIndex]?.[element?.uniqueName]


    const { error, msg: errorMsg } = !!errors ? errors : { error: false, msg: "" }


  const newRefrence = {
    specificData: currentData,
    dynamicType: elements,
    currentDynamicType: element,
    allData: data,
    currentIndex: elementIndex,
    }

  const [_, forceUpdate] = useState({});
    const render = () => forceUpdate({})

    const value = cellRef[element?.uniqueName]

  const passCurrentData = {
    dynamicType: element,
    index: elementIndex,
    ...(currentData && { currentData }),
    ...(data && { data }),
    allDynamicTypes: elements,
    values: cellRef,
    path,
    }

  const handleChange = (newValue) => {
    cellRef[element?.uniqueName] = newValue;

        const elementPath = cloneDeep(path)

    if (isHaveMultiple) {
            elementPath.push(...[currentMultipleStageIndex, element?.uniqueName])
            setValueAtPath(trackChanges, elementPath, newValue)
    } else {
            elementPath.push(element?.uniqueName)
            setValueAtPath(trackChanges, elementPath, newValue)
    }

    const clearError = () => {
      const basePath = errorRef?.error?.[mainRowIndex]?.[path.join(".")];
      if (!basePath) return;

      const target = isHaveMultiple
        ? basePath?.[currentMultipleStageIndex]?.[element.uniqueName]
        : basePath?.[element.uniqueName];

      if (target) {
        if (isHaveMultiple) {
                    basePath[currentMultipleStageIndex][element.uniqueName] = { error: false, msg: "" };
        } else {
          basePath[element.uniqueName] = { error: false, msg: "" };
        }
      }
    };

    clearError();

        element?.allReRender
            ? parantRender()
            : render();

    if (element?.reRender) {
            specificRender(cloneDeep(
                {
          value,
          ...newRefrence,
        })
      );
    }
  };


  if (!!handleSpecificDynamicType) {
    Object.keys(handleSpecificDynamicType).forEach((key) => {
            if (key === path.filter(p => typeof p !== "number").join(".")) {
                const { type = "row", handler = () => { } } = handleSpecificDynamicType[key]
        if (type === "row") {
                    const newData = handler(cloneDeep(
                        { ...passCurrentData, currentValue: value }))
          if (Object.keys(newData).includes("uniqueName", "name", "type")) {
                        element = newData
          }
        }
      }
        })
  }

  const handleDynamicError = () => {

    const singleErrorHandle = () => {
      errorRef?.data?.[mainRowIndex]?.[path.join(".")] &&
        (errorRef.data[mainRowIndex][path.join(".")] = {
          ...(errorRef?.data?.[mainRowIndex]?.[path.join(".")] ?? {}),
          [element?.uniqueName]: {
            dynamicType: element,
            value: cellRef?.[element?.uniqueName],
          },
        });
    };

    const multipleErrorHandle = () => {
      const key = path.join(".");

      // ensure the structure exists
      if (!errorRef?.data?.[mainRowIndex]) {
        errorRef.data[mainRowIndex] = {};
      }

      if (!Array.isArray(errorRef?.data?.[mainRowIndex]?.[key])) {
        errorRef.data[mainRowIndex][key] = [];
      }

      const currentError =
        errorRef?.data?.[mainRowIndex]?.[key]?.[currentMultipleStageIndex] ??
        {};

      errorRef.data[mainRowIndex][key][currentMultipleStageIndex] = {
        ...currentError,
        [element.uniqueName]: {
          dynamicType: element,
          value: cellRef?.[element?.uniqueName],
        },
      };
    };

    // const multipleErrorHandle = () => {
    //   const errorPath = errorRef?.data[mainRowIndex][path.join(".")];

    //   if (!Array.isArray(errorPath)) {
    //     errorRef.data[mainRowIndex][path.join(".")] = [];
    //   }

    //   errorRef?.data?.[mainRowIndex]?.[path.join(".")]?.[
    //     currentMultipleStageIndex
    //   ] &&
    //     (errorRef.data[mainRowIndex][path.join(".")][
    //       currentMultipleStageIndex
    //     ] = {
    //       ...(errorRef.data[mainRowIndex][path.join(".")][
    //         currentMultipleStageIndex
    //       ] ?? {}),
    //       [element.uniqueName]: {
    //         dynamicType: element,
    //         value: cellRef[element?.uniqueName],
    //       },
    //     });
    // };

    isHaveMultiple ? multipleErrorHandle() : singleErrorHandle();
  };

    handleDynamicError()

  if (element?.type === "number") {

        let defaultValueAtFirst = false
        if (!element?.MinMaxAlert &&
            ((value === "") || (value?.length === 0) || (value < element?.minValue)
                && (!!element?.minValue && (element?.minValue !== 0)))
    ) {
            cellRef[element?.uniqueName] = element?.minValue
            defaultValueAtFirst = element?.minValue
    }

    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
        }}
      >
        <CustomNumberInput
          isLabel={element?.isLabel}
          label={`Enter ${element?.name}`}
          name={element?.uniqueName}
                    value={(defaultValueAtFirst !== false) ? defaultValueAtFirst : value}
          onChange={(e) => {
                        handleChange(e?.target?.value)
          }}
          sx={{
            ...(!!element?.sx ? element?.sx : {}),
                        ...sx
          }}
          minValue={element?.minValue}
          maxValue={element?.maxValue}
          MinMaxAlert={element?.MinMaxAlert}
          error={error}
          helperText={errorMsg}
        />
      </Box>
        )
  } else if (element?.type === "dropdown") {
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
        }}
      >
        <CustomDropdown
          isLabel={element?.isLabel}
          label={`Enter ${element?.name}`}
          name={element.uniqueName}
          value={value}
          onChange={(value) => {
                        handleChange(value)
          }}
          multiple={element?.multiple ?? false}
          options={element?.options}
          sx={{
            ...(!!element?.sx ? element?.sx : {}),
                        ...sx
          }}
          renderOptionKey={
            element?.renderOptionValue ? element?.renderOptionValue : false
          }
          error={error}
          helperText={errorMsg}
        />
      </Box>
        )
  } else if (element?.type === "text") {
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
        }}
      >
        <CustomTextInput
          isLabel={element?.isLabel}
          label={`Enter ${element?.name}`}
          name={element.uniqueName}
          value={value}
          onChange={(e) => {
                        handleChange(e?.target?.value)
          }}
          sx={{
            ...(!!element?.sx ? element?.sx : {}),
                        ...sx
          }}
          error={error}
          helperText={errorMsg}
        />
      </Box>
        )
  } else if (element?.type === "checkbox-btn") {
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
        }}
      >
        <ButtonCheckbox
          value={value}
                    onChange={(e) => {
                    }}
          trueLabel="Available"
          falseLabel="Unavailable"
          color="success"
          error={error}
          helperText={errorMsg}
        />
      </Box>
        )
  } else if (element?.type === "dynamicDropdown") {
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
        }}
      >
        <CustomAutocomplete
          label={element?.name}
          name={element?.uniqueName}
          value={value}
          onChange={(value) => {
            handleChange(value);
          }}
                    options={
                        element?.options ?? []
                    }
          multiple={element?.multiple}
          freeSolo={element?.freeSolo ?? true}
          error={error}
          helperText={errorMsg}
          //   isLock={isLock || isDisable}
          isReadOnly={!!element?.isReadOnly}
          renderOptionKey={
            element?.renderOptionValue ? element?.renderOptionValue : false
          }
          isLabel={element?.isLabel}
          sx={{
            ...(!!element?.sx ? element?.sx : {}),
                        ...sx
          }}
        />
      </Box>
    );
  } else if (element?.type === "textarea") {
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
          ...(!!element?.sx ? element?.sx : {}),
          ...sx,
        }}
      >
        <CustomTextarea
          isLabel={element?.isLabel}
          label={element?.name}
          name={element?.uniqueName}
          value={value ?? ""}
          onChange={(e) => handleChange(e?.target?.value)}
          isReadOnly={!!element?.isReadOnly}
        />
      </Box>
    );
  } else if (element?.type === "file") {
    if (value) {
      // ✅ Show preview if API returned a file (metadata or File)
      return <CustomeFilePreview files={value} />;
    }
    return (
      <Box
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
          ...(!!element?.sx ? element?.sx : {}),
          ...sx,
        }}
      >
        <CustomFileInput
          isLabel={element?.isLabel}
          label={element?.name}
          name={element?.uniqueName}
          value={value}
          onChange={(e) => {
            handleChange(e?.target?.value);
          }}
          multiple={element?.multiple}
          isReadOnly={!!element?.isReadOnly}
        />
      </Box>
    );
  }
};

export default CustomDynamic;
